import { hashKey } from '@tanstack/react-query';

import type { LensFilterValues } from '~/types/leLens';

/** Card execution is a set; keep ordering out of response/cache identity. */
export function canonicalRequestedCardIds(ids?: ReadonlyArray<string>): Array<string> | undefined {
  return ids === undefined ? undefined : [...ids].sort();
}
export function lensDataRequestIdentity(
  lensId: string | undefined,
  filters: LensFilterValues,
  includeFilterOptions: boolean,
  lensVersion?: number,
  viewRevision?: number,
  requestedCardIds?: ReadonlyArray<string>,
): string {
  const key = [lensId, filters, includeFilterOptions, lensVersion, viewRevision];
  return hashKey(requestedCardIds === undefined ? key : [...key, canonicalRequestedCardIds(requestedCardIds)]);
}
export function lensDataCacheOptions(
  includeFilterOptions: boolean,
  lensVersion?: number,
  viewRevision?: number,
  requestedCardIds?: ReadonlyArray<string>,
) {
  return {
    includeFilterOptions,
    lensVersion,
    viewRevision,
    ...(requestedCardIds === undefined ? {} : { requestedCardIds: canonicalRequestedCardIds(requestedCardIds) }),
  };
}
/** A single-card refresh must not append an excluded card into a subset result. */
export function lensDataIncludesCard(requestedCardIds: ReadonlyArray<string> | undefined, cardId: string): boolean {
  return requestedCardIds === undefined || requestedCardIds.includes(cardId);
}
